import React, { useState, useRef, useEffect } from 'react'
import { Field, change } from 'redux-form'
import { useDispatch } from 'react-redux'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import { renderers, validations } from '../../../../components'

const EMAIL_DOMAINS = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com', 'yahoo.co.in',"icloud.com"]
const FORM_NAME = 'token-entry-form'

export const EmailFieldWithDomainSuggestions = ({ email = '' }: { email?: string }) => {
  const dispatch = useDispatch()
  const [filteredDomains, setFilteredDomains] = useState<string[]>([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setShowSuggestions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    const atIndex = email.indexOf('@')
    if (atIndex !== -1 && atIndex === email.length - 1) {
      setFilteredDomains(EMAIL_DOMAINS)
      setShowSuggestions(true)
    } else {
      setShowSuggestions(false)
    }
  }, [email])

  const handleSuggestionClick = (domain: string) => {
    const value = email.endsWith('@') ? email + domain : email
    dispatch(change(FORM_NAME, 'email', value))
    setShowSuggestions(false)
  }

  return (
    <div style={{ position: 'relative' }} ref={wrapperRef}>
      <Field
        name="email"
        label="Email"
        validate={[validations.required]}
        component={renderers.renderField}
        type="text"
        autoComplete="off"
      />
      {showSuggestions && (
        <ListGroup
          style={{
            position: 'absolute',
            top: '100%',
            zIndex: 1000,
            width: '100%',
            maxHeight: '150px',
            overflowY: 'auto',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            marginTop: '2px',
          }}
        >
          {filteredDomains.map((domain) => (
            <ListGroupItem
              key={domain}
              action
              onClick={() => handleSuggestionClick(domain)}
            >
              {email}{domain}
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </div>
  )
}
